import React from 'react';
import {
  BenefitCard,
  Icon,
  Title,
  Description
} from './Components';
import Text from '../common/ui/Text';
import Heading from '../common/ui/Heading';
import { Row, Col } from 'react-flexa';
import { Image, ImageContainer } from '../common/ui/Image'

const ProductCard = ({ data, ...rest }) => {
  return (
    <Row justifyContent={{ xs: "center", sm: "center", lg: "center" }}>
      {
        Array.isArray(data) && data.length !== 0 && data.map((x, i) => {
          const icon = x.icon ? x.icon : { width: '26px', height: '26px'};
          return (
            <Col key={i} style={{ padding:"10px" }}>
                <BenefitCard {...rest.cardStyle}>
                    <ImageContainer width={icon.width} height={icon.height} sWidth={icon.sWidth} sHeight={icon.sHeight}>
                        <Image src={x.icon ? x.icon.src : ''} />
                    </ImageContainer>
                    {/* title */}
                    <Heading {...rest.headingStyle}>{x.title}</Heading>
                    {/* description */}
                    <Text {...rest.textStyle}>{x.description}</Text>
                </BenefitCard>
            </Col>
          )
        })
      }
    </Row>
  )
}

export default ProductCard;